/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { default as ShareCardModel } from '../../../models/ShareCardModel';
// import Card from '../../components/card/Card';
import ShareCardHeader from './components/ShareCardHeader';
import { Locale } from '../../../utilities/localizedUtil';
import IconHealthInfo from '../../components/icons/IconHealthInfo';
import IconAttachment from '../../components/icons/IconAttachment';
import IconNote from '../../components/icons/IconNote';
import DateUtil from '../../../utilities/DateUtil';
import RouteNames from '../../appAuthorized/RouteNames';
import { Card, Icons } from '../../../bphComponents/bundle';
import { I18nImage } from '../../components/I18nTranslation';

import { useNavigate } from '../../hooks/useNavigate';
import { useShareCardForActiveProfile } from '../../hooks/useShareCard';

interface Props {
  shareCard: ShareCardModel;
  languageCode: string;
}

export const ShareCardItem: React.FC<Props> = (props) => {
  const { shareCard, languageCode } = props;
  const [, navActions] = useNavigate();
  const [, scActions] = useShareCardForActiveProfile(shareCard.data.id);
  const scColor = scActions.getShareCardColor();
  const cssColor = scColor.cssColor(1);

  return (
    <Card.CardShape style={{ backgroundColor: cssColor, margin: '8px 0' }}>
      <Card.CardContent
        onClick={() => {
          navActions.goTo(RouteNames.shareCardView(shareCard.id));
        }}
      >
        <div className="" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 8 }}>
          <div className="font-color-gsLightest font-title-2" style={{ paddingRight: 8, overflow: 'hidden', wordWrap: 'break-word' }}>
            {shareCard.title.get(languageCode)}
          </div>

          {
            !!shareCard.lightIcon &&
            <div style={{ height: 28 }}>
              <I18nImage style={{ height: 32 }} data={shareCard.lightIcon} />
            </div>
          }
        </div>

        <div className="font-color-white font-subhead">
          <div style={{ marginBottom: 8 }}>
            <FormattedMessage
              id="shareCard.lastUpdated.label"
              values={{ string1: DateUtil.formattedMediumDate(shareCard.updatedAt) }}
            />
          </div>

          {
            !shareCard.shareCardURL.isExcluded() &&
            <div style={{ marginBottom: 8 }}>
              {
                shareCard.isUrlAccessible ?
                  (
                    shareCard.lastAccessedAt
                      ? <FormattedMessage id="shareCard.urlLastAccessed.label" values={{ string1: DateUtil.formattedMediumDate(shareCard.lastAccessedAt) }}/>
                      : <FormattedMessage id="shareCard.urlNeverAccessed.label"/>
                  )
                  :
                  <FormattedMessage id="shareCard.urlDisabled.label"/>
              }
            </div>
          }

          <div
            style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}
          >
            <CountIcon Icon={IconHealthInfo.Small} count={shareCard.countHealthEntries()}/>
            <CountIcon Icon={IconAttachment.Small} count={shareCard.countFiles()}/>
            <CountIcon Icon={IconNote.Small} count={shareCard.countNotes()}/>
            <CountIcon Icon={Icons.IconProvidersContacts.Small} count={shareCard.countContacts()}/>
          </div>
        </div>
      </Card.CardContent>
    </Card.CardShape>
  );
};

const CountIcon = ({ Icon, count }) => (
  <div style={{ opacity: count ? 1 : 0.5, display: 'flex', alignItems: 'center', marginRight: 14 }}>
    <Icon color="white"/>
    <div className="font-caption-1" style={{ marginLeft: 4 }}>{count || '–'}</div>
  </div>
);
